package uz.ferro.erp.feature.order.util

import uz.ferro.erp.feature.order.model.OrderProperty
import uz.ferro.erp.util.toIntOrZero

fun List<OrderProperty>?.findData(key: String): String {
    return this?.find { pp ->
        pp.property?.key == key
    }?.property?.value.orEmpty()
}

fun List<OrderProperty>?.findIntData(key: String): Int {
    return this?.find { pp ->
        pp.property?.key == key
    }?.property?.value.toIntOrZero()
}